<template>
	<div>
		<div class="banner">
			<div class="in">
				<img class="title" src="@/assets/images/banner_home_text.png" />
				<div class="e">Light up your career and open a new chapter of wisdom</div>
				<div class="c">·打破未来界限·</div>
			</div>
			<img class="cover" src="@/assets/images/banner_cover.png" />
		</div>
		<div class="box-1">
			<img class="title-pic" src="@/assets/images/title_1.png" />
			<ul>
				<li>
					<img src="@/assets/images/icon_1.png" />
					<div class="title">地点无任何限制</div>
					<div class="info">
						<span>线上教学，突破时间、空间限制</span>
						<span>更高效的学习方式</span>
						<span>给你更高质量的生活</span>
					</div>
				</li>
				<li>
					<img src="@/assets/images/icon_2.png" />
					<div class="title">管家式服务</div>
					<div class="info">
						<span>从报名到毕业</span>
						<span>一站式服务</span>
					</div>
				</li>
				<li>
					<img src="@/assets/images/icon_3.png" />
					<div class="title">学习方式灵活</div>
					<div class="info">
						<span>不受时间及地点限制</span>
						<span>可任意选择面授</span>
						<span>和直播及远程学习</span>
					</div>
				</li>
				<li>
					<img src="@/assets/images/icon_4.png" />
					<div class="title">学习费用低</div>
					<div class="info">
						<span>推出高性价比的</span>
						<span>低价优质班型</span>
						<span>学费可分期付款</span>
					</div>
				</li>
				<li>
					<img src="@/assets/images/icon_5.png" />
					<div class="title">学习周期短</div>
					<div class="info">
						<span>比统招学习周期</span>
						<span>少3/4的时间</span>
						<span>考试合格即可申请毕业</span>
					</div>
				</li>
				<li>
					<img src="@/assets/images/icon_6.png" />
					<div class="title">投入时间少</div>
					<div class="info">
						<span>名师授课答疑解题</span>
						<span>重点俺点实时跟进分析</span>
						<span>工作学习两不误</span>
					</div>
				</li>
			</ul>
		</div>
		<div class="v-box">
			<video @ended="videoEnded" v-if="vTabActive === 0" src="../../assets/video/v1.mp4" controls></video>
			<video v-if="vTabActive === 1" src="../../assets/video/v.mp4" controls></video>
			<div class="tab">
				<div @click="changeV(0)" class="item" :class="{ 'active': vTabActive === 0 }">
					<div class="point">
						<div class="in"></div>
					</div>
					<span>公司简介</span>
				</div>
				<div @click="changeV(1)" class="item" :class="{ 'active': vTabActive === 1 }">
					<div class="point">
						<div class="in"></div>
					</div>
					<span>冠军推荐</span>
				</div>
			</div>
		</div>
		<div class="box-2">
			<div class="top">
				<img class="title-pic" src="@/assets/images/title_2.png" />
				<ul>
					<li :class="{ active: activeIndex === 0 }" @click="change(0)">
						<img src="@/assets/images/tab_icon_1.png" />
						<span>学历提升</span>
						<div class="line"></div>
					</li>
					<li :class="{ active: activeIndex === 1 }" @click="change(1)">
						<img src="@/assets/images/tab_icon_2.png" />
						<span>技能提升</span>
						<div class="line"></div>
					</li>
				</ul>
			</div>
			<div class="main">
				<img class="person" src="@/assets/images/person.png" />
				<div class="right">
					<div class="title">
						<span class="t1" v-if="activeIndex === 0">「佰小轩」学历教育</span>
						<span class="t1" v-if="activeIndex === 1">「佰小轩」技能教育</span>
						<span class="t2" v-if="activeIndex === 0">学历证书国家教育部认可，学信网可查</span>
						<span class="t2" v-if="activeIndex === 1">培养AI新时代具有工匠精神的技能型人才</span>
					</div>
					<ul v-if="activeIndex === 0">
						<li>
							<div>成人继续教育培训</div>
							<span>自考 成考 开放教育</span>
						</li>
						<li>
							<div>研究生</div>
							<span>同等学力申硕 管理类联考</span>
						</li>
					</ul>
					<ul v-if="activeIndex === 1">
						<li>
							<div>设计类</div>
							<span>插画 原画 平面设计</span>
						</li>
						<li>
							<div>新职业</div>
							<span>Ai技能 直播主播</span>
						</li>
					</ul>
					<div class="list" v-if="activeIndex === 0">
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">突破瓶颈</span>
								<span class="t2">多年职场的锻炼，可能在管理、专业上遇到瓶颈，需要突破。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">高命中率</span>
								<span class="t2">高薪聘请10年经验教研老师，对历年真题、 考题、 教材进行整合，涵盖80%的考点。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">证书含金量高</span>
								<span class="t2">国内一流重点大学学历，含金量比肩统招，社会认可度高。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">福利政策</span>
								<span class="t2">新一二线城市引入人才，对高学历毕业生有更多倾斜，包括生活、住房补贴，落户等。</span>
							</div>
						</div>
					</div>

					<div class="list" v-if="activeIndex === 1">
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">升职加薪</span>
								<span class="t2">为你自己带来一次切换竞争赛道的机会。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">教学体系标准化</span>
								<span class="t2">讲师与助教同步在线，预习/复习/课后练习三管齐下。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">12小时贴心助学</span>
								<span class="t2">名师授课答疑解题，重点难点实时跟进分析，工作学习两不误。</span>
							</div>
						</div>
						<div class="item">
							<img class="check" src="@/assets/images/check.png" />
							<div class="info">
								<span class="t1">学用结合</span>
								<span class="t2">注重学用结合，提供实践机会，无缝对接变现渠道。</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="scroll-box">
				<ul :style="style">
					<li>
						<img src="@/assets/images/工商管理.jpg" />
					</li>
					<li>
						<img src="@/assets/images/国开本科法学.png" />
					</li>
					<li>
						<img src="@/assets/images/南理工 函授.jpg" />
					</li>
					<li>
						<img src="@/assets/images/南师汉语.jpg" />
					</li>
					<li>
						<img src="@/assets/images/行政 (2).jpg" />
					</li>
					<li>
						<img src="@/assets/images/自考毕业证书.jpg" />
					</li>
				</ul>
			</div>
			<div class="arrow">
				<img @click="left()" src="@/assets/images/arrow_left.png" />
				<img @click="right()" src="@/assets/images/arrow_right.png" />
			</div>
		</div>
		<div class="news-box">
			<div class="title">
				<img src="@/assets/images/news_title.png" />
			</div>
			<div class="tab">
				<div v-for="item in tabs" class="item" :class="{ 'active': tabActive === item.dictValue }"
					@click="changeType(item.dictValue)">
					<div class="point"></div>
					<span>{{ item.dictLabel }}</span>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item, index) in news" @click="goDetail(item, index)">
					<img :src="item.pic" style="object-fit: cover;">
					<h3>{{ item.title }}</h3>
					<div class="info">
						<span class="time">{{ item.pushDate }}</span>
						<span class="form">{{ item.mediaChannel }}</span>
					</div>
					<div class="des">{{ item.excerpt }}</div>
				</div>
			</div>

			<div class="more" @click="goList()">查看更多内容</div>
		</div>
		<div class="box-3">
			<img class="title-pic" src="@/assets/images/title_3.png" />
			<div class="info">
				<div>作为成人在线教育专业机构，<i>「佰小轩」</i>不断深耕继续教育领域及AI新职业技能培训领域，</div>
				<div>致力于培养VUCA时代具有<i>工匠精神的技能型人才，</i></div>
				<div><i>助力有志青年点亮职业生涯，开启人生新篇章！</i></div>
			</div>
		</div>
		<div class="box-4">
			<img class="title-pic" src="@/assets/images/title_4.png" />
			<div class="cards">
				<div class="card1">
					<div class="title">核心团队</div>
					<div class="line"></div>
					<div class="info">
						自2011年创立，拥有“南京宏卓教育培训中心（教育局认证资质）”
						“远上云端成人教育专修中心（教育局认证资质）”2所直营培训学校。
					</div>
				</div>
				<div class="card2">
					<div class="title">产品服务</div>
					<div class="line"></div>
					<div class="info">
						成人继续教育培训（自考、成考、国开），研究生（同等学力申硕、管理类联考）。
						新职业技能课程（AI技术、LIVE 2D、游戏原画、商业插画）等多类新职业技能课程。
					</div>
				</div>
				<div class="card3">
					<div class="title">课程体系</div>
					<div class="line"></div>
					<div class="info">
						搭建了互联网+Al教育模式科技平台及网络教育课程平台，研发了独特的课程体系。
					</div>
				</div>
				<div class="card4">
					<div class="title">师资力量</div>
					<div class="line"></div>
					<div class="info">
						与武汉大学等高校优秀师资建立跨区域的互联网平台教学，与南京大学等10多所高校开展校企合作，并与多家教育机构达成长期战略合作伙伴关系，持续探索继续教育新模式。
					</div>
				</div>
			</div>

			<div class="scroll-box">
				<ul :style="style1">
					<li>
						<img src="@/assets/images/3A等级证书_05.jpg" />
					</li>
					<li>
						<img src="@/assets/images/3A等级证书_05.jpg" />
					</li>
					<li>
						<img src="@/assets/images/3A等级证书_06.jpg" />
					</li>
					<li>
						<img src="@/assets/images/诚信经营.jpg" />
					</li>
					<li>
						<img src="@/assets/images/教育领域.jpg" />
					</li>
					<li>
						<img src="@/assets/images/企业信用.jpg" />
					</li>

					<li>
						<img src="@/assets/images/企业资信.jpg" />
					</li>
					<li>
						<img src="@/assets/images/信用等级.jpg" />
					</li>
					<li>
						<img src="@/assets/images/质量服务.jpg" />
					</li>
					<li>
						<img src="@/assets/images/50.30.jpg" />
					</li>
					<li>
						<img src="@/assets/images/品牌强国.jpg" />
					</li>
					<li>
						<img src="@/assets/images/厦门诚信促进会会员_00.jpg" />
					</li>
					<li>
						<img src="@/assets/images/品牌成员单位.jpg" />
					</li>
				</ul>
			</div>
			<div class="arrow">
				<img @click="left1()" src="@/assets/images/arrow_left.png" />
				<img @click="right1()" src="@/assets/images/arrow_right.png" />
			</div>
		</div>
	</div>
</template>

<script>
import { queryListFromH5, getNewsTab } from '@/axios/api.js'
export default {
	data() {
		return {
			activeIndex: 0,
			style: '',
			x: 0,
			vTabActive: 0,
			style1: '',
			x1: 0,

			timer: null,
			timer1: null,
			tabs: [],
			tabActive: '',
			news: [],
		}
	},
	created() {
		getNewsTab().then(res => {
			this.tabs = res.data.data
			this.tabActive = this.tabs[0].dictValue

			this.getNews()
		})
	},
	mounted() {

	},
	computed: {},
	watch: {},
	methods: {
		goList() {
			this.$router.push('/news')
		},
		goDetail(item, index) {
			if(item.jumpType === '外部链接'){
				window.open(item.outLink)
			}else{
				this.$router.push(`/detail?id=${item.id}&tab=${this.tabActive}&nodeNum=${index + 1}`)
			}
		},
		getNews() {
			this.news = []
			let params = {
				pageNum: 1,
				pageSize: 6,
				tab: this.tabActive,
				topUp:1,
			}
			queryListFromH5(params).then(res => {
				this.news = res.data.data.list
			})
		},
		changeType(dictValue) {
			this.tabActive = dictValue
			this.getNews()
		},
		change(index) {
			this.activeIndex = index
		},
		right() {
			if (this.x < -270) {
				return
			}
			this.x = this.x - 270
			this.style = `transform: translateX(${this.x}px)`
		},
		left() {
			if (this.x >= 0) {
				return
			}
			this.x = this.x + 270
			this.style = `transform: translateX(${this.x}px)`
		},

		right1() {
			if (this.x1 < -2160) {
				return
			}
			this.x1 = this.x1 - 270
			this.style1 = `transform: translateX(${this.x1}px)`
		},
		left1() {
			if (this.x1 >= 0) {
				return
			}
			this.x1 = this.x1 + 270
			this.style1 = `transform: translateX(${this.x1}px)`
		},

		videoEnded() {
			this.vTabActive = 1
		},
		changeV(index) {
			this.vTabActive = index
		}
	},
	beforeDestroy() {

	},
	components: {
	}
}
</script>

<style scoped lang="less">
.news-box {
	padding: 60px 0;
	background: #EEF5FE url('../../assets/images/news_bg.png') top center no-repeat;
	background-size: 100% auto;

	.title {
		margin-bottom: 28px;

		img {
			width: 184px;
			height: auto;
			display: block;
			margin: 0 auto;
		}
	}

	.tab {
		width: 1180px;
		margin: 0 auto 28px auto;
		display: flex;
		align-items: center;

		.item {
			margin-right: 65px;
			display: flex;
			align-items: center;
			cursor: pointer;

			.point {
				display: none;
				background: #1C65FF;
				width: 10px;
				height: 10px;
				border-radius: 50%;
				border: #BDDCFE 3px solid;
			}

			span {
				color: #BDDCFE;
				font-size: 26px;
				padding-left: 6px;
				font-weight: 500;
			}

			&.active {
				.point {
					display: flex;
				}

				span {
					color: #1A7EFD;
					font-weight: bold;
				}
			}


		}
	}

	.list {
		width: 1196px;
		margin: 0 auto 50px auto;
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 382px;
			height: 370px;
			padding: 16px;
			box-sizing: border-box;
			background: #fff;
			margin: 0 8px 40px 8px;
			cursor: pointer;

			img {
				width: 100%;
				height: 148px;
			}

			h3 {
				margin-bottom: 12px;
				font-size: 18px;
			}

			.info {
				margin-bottom: 12px;

				span {
					font-size: 12px;

					&.time {
						color: #AEB3C0;
						margin-right: 16px
					}
				}
			}

			.des {
				color: #AEB3C0;
				font-size: 15px;
			}
		}
	}

	.more {
		color: #AEB3C0;
		font-size: 18px;
		background: #fff;
		border-radius: 6px;
		height: 60px;
		width: 240px;
		display: flex;
		margin: 0 auto;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
}

.v-box {
	height: 768px;
	background: url('../../assets/images/yj_bg.png') center center no-repeat;
	background-size: cover;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	video {
		width: 1178px;
		height: 662px;
		margin-bottom: 10px;
	}

	.tab {
		width: 1178px;
		display: flex;
		align-items: center;

		.item {
			margin-right: 35px;
			display: flex;
			align-items: center;
			cursor: pointer;

			.point {
				width: 18px;
				height: 18px;
				background: rgba(255, 255, 255, 0.2);
				border-radius: 50%;
				margin-right: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				opacity: 0.5;

				.in {
					width: 10px;
					height: 10px;
					background: rgba(255, 255, 255, 1);
					border-radius: 50%;
				}
			}

			span {
				color: rgba(255, 255, 255, 0.3);
				font-size: 26px;
				font-weight: 500;
			}

			&.active {
				.point {
					opacity: 1;
				}

				span {
					color: #fff;
				}
			}
		}
	}
}

.banner {
	position: relative;
	height: 700px;
	background: url('../../assets/images/banner_home.png') center center no-repeat;
	background-size: cover;

	.cover {
		height: 88px;
		position: absolute;
		width: 100%;
		left: 0;
		right: 0;
		bottom: -4px;
		z-index: 1;
	}

	.in {
		position: absolute;
		z-index: 1;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		.title {
			width: 1000px;
			height: auto;
			margin-bottom: 10px;
		}

		.e {
			font-weight: 400;
			color: #fff;
			font-size: 18px;
			letter-spacing: 1.8px;
			text-transform: uppercase;
			margin-bottom: 8px;
		}

		.c {
			font-weight: 400;
			color: #fff;
			font-size: 23px;
			letter-spacing: 12px;
			text-transform: uppercase;
			text-shadow: rgba(0, 6, 166, .47) 0 2px 10px;
		}
	}
}

.box-1 {
	padding: 50px 0;

	.title-pic {
		height: 83px;
		width: auto;
		display: block;
		margin: 0 auto 50px auto;
	}

	ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		width: 1187px;
		margin: 0 auto;

		li {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 340px;
			height: 360px;
			background: #F7F9FC;
			border-radius: 8px;
			margin: 0 30px 30px 30px;
			cursor: default;

			&:nth-child(1),
			&:nth-child(4) {
				margin: 0 30px 30px 0px;
			}

			&:nth-child(3),
			&:nth-child(6) {
				margin: 0 0px 30px 30px;
			}

			img {
				width: 190px;
				height: 190px;
			}

			.title {
				color: #24242A;
				font-weight: bold;
				font-size: 24px;
				margin-bottom: 16px;
			}

			.info {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				span {
					font-size: 18px;
					color: #AEB3C0;
				}
			}

			&:hover {
				background: #fff;
				box-shadow: rgba(0, 57, 131, 0.1) 0 6px 29px;
			}
		}
	}
}

.box-2 {
	padding: 50px 0;
	background: #EFF2FB;

	.top {
		width: 1178px;
		margin: 0 auto 25px auto;
		display: flex;
		border-bottom: #AEB3C0 1px solid;
		justify-content: space-between;
		// padding-bottom: 20px;
		align-items: center;

		.title-pic {
			height: 97px;
			width: auto;
		}

		ul {
			display: flex;
			padding-right: 20px;

			li {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-left: 140px;
				cursor: pointer;

				img {
					width: 100px;
					height: 100px;
				}

				span {
					color: #24242A;
					opacity: 0.5;
					font-size: 20px;
					font-weight: 500;
					padding-bottom: 20px;
				}

				.line {
					background: transparent;
					width: 120px;
					height: 10px;
				}

				&.active {
					span {
						color: #1A7EFD;
						opacity: 1;
					}

					.line {
						background: linear-gradient(to right, #38B5FF, #1A7EFD);
						width: 120px;
						height: 10px;
					}
				}
			}
		}
	}

	.scroll-box {
		overflow-x: hidden;
		overflow-y: visible;
		margin: 0 auto;
		padding-top: 20px;
		padding-right: 0;
		padding-bottom: 40px;
		padding-left: calc((100vw - 1178px) / 2);

		ul {
			display: flex;
			width: 3000px;
			transition: all 0.3s ease-in-out;

			li {
				background: #fff;
				box-sizing: border-box;
				border-radius: 8px;
				padding: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 187px;
				width: 250px;
				margin-right: 20px;
				box-shadow: rgba(0, 37, 84, .2) 0 6px 30px;

				img {
					max-width: 100%;
					max-height: 100%;
				}
			}
		}
	}

	.arrow {
		width: 1178px;
		margin: 0 auto 0px auto;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 24px;
			height: 19px;
			margin: 0 30px;
			cursor: pointer;

			&:hover {
				opacity: 0.7;
			}
		}
	}

	.main {
		width: 1178px;
		margin: 0 auto 0px auto;
		background: #fff;
		border-radius: 8px;
		box-shadow: rgba(0, 37, 84, 0.2) 0 6px 30px;
		height: 512px;
		display: flex;

		.person {
			height: 512px;
			width: auto;
		}

		.right {
			padding-top: 30px;
			padding-left: 60px;

			.title {
				display: flex;
				align-items: center;
				margin-left: -15px;
				margin-bottom: 30px;

				.t1 {
					font-size: 26px;
					font-weight: 500;
					color: #24242A;
					margin-right: 14px;
				}

				.t2 {
					color: #AEB3C0;
					font-size: 20px;
				}
			}

			ul {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				li {
					width: 309px;
					height: 83px;
					border-radius: 8px;
					border: rgba(188, 204, 225, 0.5) 1px solid;
					margin-right: 22px;

					div {
						display: flex;
						align-items: center;
						justify-content: center;
						color: #1A7EFD;
						font-size: 22px;
						background: rgba(26, 126, 253, 0.05);
						height: 42px;
					}

					span {
						display: flex;
						align-items: center;
						justify-content: center;
						color: #24242A;
						padding-top: 8px;
						font-size: 18px;
					}
				}
			}

			.list {
				.item {
					display: flex;
					margin-bottom: 18px;

					img {
						height: 21px;
						width: auto;
						margin-right: 18px;
					}

					.info {
						display: flex;
						flex-direction: column;

						.t1 {
							font-size: 18px;
							color: #3B4664;
						}

						.t2 {
							font-size: 14px;
							color: #AEB3C0;
						}
					}
				}
			}
		}
	}
}

.box-3 {
	height: 468px;
	background: url('../../assets/images/yj_bg.png') center center no-repeat;
	background-size: cover;
	box-sizing: border-box;
	padding-top: 40px;

	.title-pic {
		display: block;
		margin: 0 auto;
		height: 90px;
		width: auto;
	}

	.info {
		padding-top: 76px;
		color: #fff;
		font-size: 26px;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-weight: 500;

		div {
			i {
				color: #27CBFF;
			}
		}
	}
}

.box-4 {
	// height: 724px;
	background: url('../../assets/images/why_bg.png') center center no-repeat;
	background-size: cover;
	box-sizing: border-box;
	padding-top: 60px;
	padding-bottom: 60px;

	.title-pic {
		display: block;
		margin: 0 auto 60px auto;
		height: 53px;
		width: auto;
	}

	.cards {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		width: 1178px;
		margin: 0 auto;

		.card1 {
			width: 710px;
			height: 228px;
			background: url('../../assets/images/w_1_bg.png') center center no-repeat;
			background-size: cover;
			margin: 0 20px 20px 0;

			.info {
				width: 424px;
			}
		}

		.card2 {
			width: 430px;
			height: 228px;
			background: url('../../assets/images/w_2_bg.png') center center no-repeat;
			background-size: cover;

			.info {
				width: 350px;
			}
		}

		.card3 {
			width: 437px;
			height: 228px;
			background: url('../../assets/images/w_3_bg.png') center center no-repeat;
			background-size: cover;
			margin: 0 20px 0 0;

			.info {
				width: 350px;
			}
		}

		.card4 {
			width: 702px;
			height: 228px;
			background: url('../../assets/images/w_4_bg.png') center center no-repeat;
			background-size: cover;

			.info {
				width: 424px;
			}
		}

		.title {
			color: #fff;
			font-size: 22px;
			padding: 23px 0 0 30px;
			margin-bottom: 8px;
		}

		.line {
			background: #fff;
			width: 36px;
			height: 2px;
			margin-left: 30px;
			margin-bottom: 36px;
		}

		.info {
			color: #fff;
			font-size: 14px;
			margin-left: 30px;
		}
	}

	.scroll-box {
		overflow-x: hidden;
		overflow-y: visible;
		margin: 0 auto;
		padding-top: 20px;
		padding-right: 0;
		padding-bottom: 40px;
		padding-left: calc((100vw - 1178px) / 2);

		ul {
			display: flex;
			width: 8000px;
			transition: all 0.3s ease-in-out;

			li {
				background: #fff;
				box-sizing: border-box;
				border-radius: 8px;
				padding: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 187px;
				// width: 250px;
				margin-right: 20px;
				box-shadow: rgba(0, 37, 84, .2) 0 6px 30px;

				img {
					max-width: auto;
					height: 167px;
				}
			}
		}
	}

	.arrow {
		width: 1178px;
		margin: 0 auto 0px auto;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 24px;
			height: 19px;
			margin: 0 30px;
			cursor: pointer;

			&:hover {
				opacity: 0.7;
			}
		}
	}
}
</style>
